import React from 'react';
import { connect } from 'react-redux';


class EquivocalImportantInfo extends React.Component {

    // FIXME Styles/layout
    render() {
        return (
            <div>
                <div><b style={{color:'red', fontWeight: 'bold'}}>{this.props.strings.IMPORTANT_EQUIVOCAL_MESSAGE} </b>{this.props.strings.IMPORTANT_EQUIVOCAL_MESSAGE_2}</div><br/>
                <p>
                    {this.props.strings.IMPORTANT_EQUIVOCAL_MESSAGE_3}
                    <b><a href={this.props.strings.COVID_MAIN_PAGE_LINK}>{this.props.strings.IMPORTANT_EQUIVOCAL_MESSAGE_4}</a></b>
                </p>
                <div>
                    <p>
                        {this.props.strings.IMPORTANT_PAXLOVID_MESSAGE_1A}
                        <strong>
                            <a href={this.props.strings.TREATMENT_LINK}>{this.props.strings.IMPORTANT_PAXLOVID_MESSAGE_1B}</a>
                        </strong>
                        {this.props.strings.IMPORTANT_PAXLOVID_MESSAGE_1C}
                    </p>
                </div>
            </div>
        );
    }
}

const mapStateToProps = (state, ownProps) => {
    return {
        strings: state.language.strings,
    }
}

const ConnectedEquivocalImportantInfo = connect(
    mapStateToProps
)(EquivocalImportantInfo);
export default ConnectedEquivocalImportantInfo;
